import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const giftWithPurchaseAddProductRolesRBAC = {
  pageID: 'b9a9b31413213f918bd84ac000fc0706',
  elementID: {
    ViewPage: 'e7e53ca4bcde587deff64e499e932c70',
  },
} as const

export const useRBACGiftWithPurchaseAddProductPage = createUseRBAC(
  giftWithPurchaseAddProductRolesRBAC.elementID,
)

export type UseRBACGiftWithPurchaseAddProductPageType = ReturnType<
  typeof useRBACGiftWithPurchaseAddProductPage
>
